// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bb-4";
export var collapsed = "_bb-1";
export var headerBar = "_bb-0";
export var leftHeaderContent = "_bb-3";
export var subjectContainer = "_bb-2";